import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			aboutAboutHeliumDrivesContentSectionHeaderCls: string;
			aboutAboutHeliumDrivesContentSectionSubheaderCustomCls: string;
			aboutAboutHeliumDrivesContentSectionTextInnerCls: string;
		}
	},

	slug: string
}

class Drives extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('About About Helium Drives Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.aboutAboutHeliumDrivesContentSectionHeaderCls || '','about_about_helium_drives', { animCls: 'animate__fadeInLeft25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.aboutAboutHeliumDrivesContentSectionSubheaderCustomCls || '','about_about_helium_drives', { animCls: 'animate__fadeInDown', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.aboutAboutHeliumDrivesContentSectionTextInnerCls || '','about_about_helium_drives', { animCls: 'animate__fadeInRight25P', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Drives;